import * as types from "./mutation-type";

export default {
    [types.SET_PURCHASES](state, payload) {
        state.purchases = payload;
    },
    [types.SET_PAGINATION](state, payload) {
        state.pagination = payload;
    }
};
